<template>
    <tr class="transition duration-200 hover:bg-gray-100" class2="cursor-pointer">
        <td class="border-b px-2 py-1 text-sm">
            <a @click.prevent="openStore" :href="listing.store.link">
                <div class="font-semibold sm:whitespace-no-wrap">
                    {{ listing.store.name }}
                </div>

                <div v-if="listing.store.image_url" class="store-avatar mt-2" class2="avatar">
                    <img :src="listing.store.image_url" :alt="listing.store.name" class="block p-1 rounded-circle bg-white w-10 h-10" />
                </div>
            </a>
        </td>
        <td class="border-b px-2 py-1 text-sm">
            <!-- <b-tooltip :target="'listing-' + listing.id" triggers="hover" placement="left" delay="500" boundary="window">
                <img :src="listing.image_url" :alt="listing.name" class="bg-white img-thumbnail listing-preview" />
            </b-tooltip> -->

            <a @click.prevent="openListing" :href="listingUrl" :id="'listing-' + listing.id" target="_blank" rel="nofollow">
                {{ listing.name }}
            </a>

            <span class="mt-2 block sm:hidden">
                <follow-listing-button :listing="listing" btn-class="btn-xs" />
            </span>

            <span v-if="listing.restricted" v-b-tooltip.hover title="This product is restricted for buyers.">
                <!-- <fa-icon :icon="['fas', 'bolt']" /> -->
                <i class="far fa-bolt"></i>
            </span>
        </td>
        <td class="border-b px-2 py-1">
            <span v-cloak v-if="listing.stocked === true" class="badge badge-success text-xs rounded">
                In Stock
            </span>
            <span v-cloak v-if="listing.stocked === false" class="badge badge-warning text-xs rounded">
                Sold Out
            </span>
            <!-- <span v-cloak v-if="listing.stocked === null" class="badge badge-dark text-xs rounded">
                Unknown
            </span> -->

            <div v-if="isAdminUser" class="text-xs text-gray-600">
                <span v-if="listing.checked_at">
                    <span>{{ relative(listing.checked_at) }}</span>
                </span>
            </div>
        </td>
        <td class="border-b px-2 py-1">
            <h6 class="font-semibold text-gray-800 text-base">
                <span v-if="listing.stocked === true && listing.price !== null">
                    {{ currency(listing.price) }}
                </span>
                <span v-if="listing.stocked === true && listing.price === null">
                    See Site
                </span>
                <span v-if="listing.stocked === false">
                    &ndash;
                </span>
            </h6>
        </td>
        <td class="border-b px-2 py-1 text-xs text-gray-600 hidden sm:table-cell">
            <span v-if="listing.stocked !== true && listing.stocked_at" :title="dateTime3(listing.stocked_at)">
                {{ dateTime(listing.stocked_at) }}
            </span>
            <span v-else>
                &ndash;
            </span>
        </td>
        <td class="border-b px-2 py-1 hidden sm:table-cell">
            <div v-cloak v-if="listing.stocked">
                <a @click.prevent="openListing" :href="listingUrl" :class="{'btn-primary': listing.stocked, 'btn-secondary': !listing.stocked}" class="btn btn-xs border-2 rounded-full font-semibold">
                    <i class="fad fa-shopping-cart fa-lg mr-1"></i>
                    Buy Now
                    <!-- <span v-cloak v-if="listing.stocked">
                        Buy Now
                    </span>
                    <span v-cloak v-if="!listing.stocked">
                        <i class="far fa-external-link-square fa-lg mr-1"></i>
                        View Item
                    </span> -->
                </a>
            </div>

            <div v-cloak v-if="!listing.stocked">
                <follow-listing-button :listing="listing" btn-class="btn-xs" />
            </div>
        </td>
    </tr>
</template>

<script>
import numeral from "numeral";
import ListingMixin from '../../mixins/listing';
import StoreMixin from '../../mixins/store';

export default {
    mixins: [
        ListingMixin,
        StoreMixin
    ],

    props: ['listing'],

    data: () => ({}),

    created() {
        Bus.$on("productListingChecked", listing => {
            if (this.listing.id === listing.id) {
                // this.listing = listing;
                this.listing.price = listing.price;
                this.listing.stocked = listing.stocked;
                this.listing.checked_at = listing.checked_at;
                this.listing.stocked_at = listing.stocked_at;
                this.listing.updated_at = listing.updated_at;
            }
        });
    },

    mounted() {},

    computed: {
        store() {
            return this.listing.store;
        }
    },

    methods: {}
}
</script>

<style lang="scss" scoped>
.listing-preview {
    max-height: 150px;
    max-width: 150px;
}
</style>
